import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckIcon from '@mui/icons-material/Check';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';

const Tab = props => {
  const {
    className,
    id,
    disabled,
    text,
    selected,
    linkProps,
    stepNumber,
    stepState,
    useStepNav,
  } = props;
  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
    [css.stepLink]: useStepNav,
    [css.stepLinkCurrent]: useStepNav && stepState === 'current',
    [css.stepLinkCompleted]: useStepNav && stepState === 'completed',
    [css.stepLinkUpcoming]: useStepNav && stepState === 'upcoming',
  });

  const stepIndicator = useStepNav ? (
    <span className={css.stepIndicator} aria-hidden>
      {stepState === 'completed' ? (
        <CheckIcon className={css.stepCheckIcon} fontSize="inherit" />
      ) : (
        stepNumber
      )}
    </span>
  ) : null;

  return (
    <div id={id} className={className}>
      <NamedLink className={linkClasses} {...linkProps}>
        {stepIndicator}
        <span className={css.stepLabel}>{text}</span>
      </NamedLink>
    </div>
  );
};

Tab.defaultProps = {
  className: null,
  disabled: false,
  selected: false,
  stepNumber: null,
  stepState: null,
  useStepNav: false,
};

const { arrayOf, bool, node, number, object, string } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
  stepNumber: number,
  stepState: string,
  useStepNav: bool,
};

const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs, useStepNav } = props;
  const classes = classNames(rootClassName || css.root, className, useStepNav && css.stepNavRoot);
  const tabClasses = tabRootClassName || css.tab;
  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return <Tab key={id} id={id} className={tabClasses} useStepNav={useStepNav} {...tab} />;
      })}
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
  tabClassName: null,
  useStepNav: false,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
  useStepNav: bool,
};

export default TabNav;
